import { BulkDataType, BulkActionConfig } from 'types';

export const BULK_ACTION_CONFIGS: Record<BulkDataType, BulkActionConfig> = {
  trainingAndStandardisationSessions: {
    title: 'Training and standardisation sessions',
    templateKey: 'trainingAndStandardisationSessions',
  },
  speakingMonitorings: {
    title: 'Speaking monitorings',
    templateKey: 'speakingMonitorings',
  },
  osmMonitoringResults: {
    title: 'OSM monitoring results',
    templateKey: 'osmMonitoringResults',
  },
  examinerContactDetails: {
    title: 'Examiner contact details',
    templateKey: 'examinerContactDetails',
  },
  examinerRoles: {
    title: 'Examiner roles',
    templateKey: 'examinerRoles',
  },
  osmMonitoringArchiving: {
    title: 'OSM monitoring archiving',
    templateKey: 'osmMonitoringArchiving',
  },
  examinerCentres: {
    title: 'Examiner centres',
    templateKey: 'examinerCentres',
  },
  speakingCertifications: {
    title: 'Speaking certifications',
    templateKey: 'speakingCertifications',
  },
  writingCertifications: {
    title: 'Writing certifications',
    templateKey: 'writingCertifications',
  },
  odpAssessments: {
    title: 'ODP assessments',
    templateKey: 'odpAssessments',
  },
  odpMonitorings: {
    title: 'ODP monitorings',
    templateKey: 'odpMonitorings',
  },
};
